import Vue from 'vue';
export default Vue.extend({
    props: {
        visible: { type: Boolean, default: true },
        clickToClose: { type: Boolean, default: true },
    },
    methods: {
        mousedown(event) {
            const target = event.target;
            if (this.clickToClose && target?.className === "modal-wrapper")
                this.$emit('will-close', event);
        },
        mouseleave(event) {
            const target = event.target;
            if (this.clickToClose && target?.className === "modal-wrapper")
                this.$emit('will-not-close', event);
        },
        close(event) {
            const target = event.target;
            if (this.clickToClose && target?.className === "modal-wrapper")
                this.$emit('close', event);
        }
    }
});
